module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isSplash()) ? _c('div', {
    staticClass: "mdl-cell--hide-desktop mdl-cell--hide-tablet mdl-layout__drawer"
  }, [(!_vm.user) ? _c('router-link', {
    staticClass: "adv-sign-in-button adv-signed-out-only mdl-button mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "to": "/login"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("account_circle")]), _vm._v(" Sign in")]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "adv-signed-in-user-container mdl-color--deep-orange adv-signed-in-only"
  }, [_c('a', {
    staticClass: "adv-usernamelink"
  }, [_c('div', {
    staticClass: "adv-avatar",
    style: (_vm.getUserAvatar())
  }), _vm._v(" "), _c('div', {
    staticClass: "adv-username mdl-color-text--white"
  }, [_vm._v(_vm._s(_vm.user && (_vm.user.displayName || _vm.user.email)))])])]) : _vm._e(), _vm._v(" "), _c('nav', {
    staticClass: "mdl-navigation"
  }, [_c('div', {
    staticClass: "nav-separator-title"
  }, [_vm._v("Play")]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("gamepad")]), _vm._v(" Adventures")]), _vm._v(" "), (_vm.user) ? _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": "/recent"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("history")]), _vm._v(" Recently Played")]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "nav-separator-title"
  }, [_vm._v("Create")]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": "/editor"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("create")]), _vm._v(" Adventure Editor")]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": "/documentation"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("local_library")]), _vm._v(" Documentation")]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "nav-separator-title"
  }, [_vm._v("Account")]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('button', {
    staticClass: "adv-sign-out mdl-navigation__link",
    staticStyle: {
      "border": "none"
    },
    on: {
      "click": _vm.logOut
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("exit_to_app")]), _vm._v(" Sign Out")]) : _vm._e()], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b47f663e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionDrawerMenu.vue
// module id = 317
// module chunks = 0